import type {
  ChainModifiers,
  Entry,
  EntryFieldTypes,
  EntrySkeletonType,
  LocaleCode,
} from 'contentful';

export interface TypeEmbeddedNoteFields {
  internalName: EntryFieldTypes.Symbol;
  heading?: EntryFieldTypes.Symbol;
  content: EntryFieldTypes.RichText;
  variant?: EntryFieldTypes.Symbol<'featured' | 'important' | 'info'>;
  showIcon?: EntryFieldTypes.Boolean;
  sectionId?: EntryFieldTypes.Symbol;
}

export type TypeEmbeddedNoteSkeleton = EntrySkeletonType<TypeEmbeddedNoteFields, 'embeddedNote'>;
export type TypeEmbeddedNote<
  Modifiers extends ChainModifiers,
  Locales extends LocaleCode = LocaleCode,
> = Entry<TypeEmbeddedNoteSkeleton, Modifiers, Locales>;

export function isTypeEmbeddedNote<Modifiers extends ChainModifiers, Locales extends LocaleCode>(
  entry: Entry<EntrySkeletonType, Modifiers, Locales>,
): entry is TypeEmbeddedNote<Modifiers, Locales> {
  return entry.sys.contentType.sys.id === 'embeddedNote';
}
